<template>
    <div class="democreditloginPopup">
        <div class="fadeinDemo">
            <div class="popup-box">
                <!--div class="guide-close-button floating-right">
                    <i class="fa fa-times-circle fa-2x" @click="closePopup"></i>
                </div-->
                <div class="message">
                    <div class="demo_caption">
                        <span>{{lang.entertoken}}</span>
                    </div>
                    <div class="demo_token">
                        <input type="text" id="tokendemo" maxlength="8" v-model="token_demo" >
                    </div>

                    <!-- error -->
                    <div id="div_error" class="div_error" name="div_error">
                        <div id="error_msg" class="error_msg" v-show="error.tokenReq">
                            {{ error.tokenmessage }}
                        </div>
                    </div>

                    <div class="btn_submit">
                        <button type="submit" class="btn btn_sb" @click.prevent="login" tabindex="3">{{lang.submit}}</button>
                        <button type="submit" class="btn btn_cc" @click.prevent="closePopup" tabindex="3">{{lang.cancel}}</button>
                    </div>
                    <!--div class="btn_cancel">
                        <button type="submit" class="btn btn_cc" @click.prevent="closePopup" tabindex="3">Cancel</button>
                    </div-->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import popupCommon from '../mixins/popup'
    export default {
        mixins: [popupCommon],
        props: {
            democreditLogin : Boolean,
            lang:null,
            emptytoken:null,
            invalidtoken:null,
        },
        data() {
            return {
                token_demo : this.token_demo,
                error: {
                    tokenReq: false,
                    tokenmessage: '',
            },
            }
        },
        mounted() {
            this.popupBreath()
        }
    }
</script>


// WEBPACK FOOTER //
// resources/wob/vue/components/popup.vue